/* custom-policy-pages.js
 * Same-page anchor navigation for the policy pages (scenario chooser etc.).
 * Horizon's link router intercepts same-origin clicks for view transitions,
 * which swallows in-page hash jumps (URL updates, no scroll). Handle them
 * ourselves in the capture phase, before the router sees the click.
 * scrollIntoView honours the scroll-margin-top offset in custom-policy-pages.css
 * and works whether the scroller is the window or .page-wrapper.
 * Shared asset — keep in sync between Phaser and CCC repos.
 */
(() => {
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('.policy-page a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      history.pushState(null, '', link.getAttribute('href'));
      /* 'auto' (instant), not 'smooth': smooth animations get throttled in
       * background windows and can lose to the theme's own scroll handling —
       * instant matches native anchor behaviour and always arrives. */
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    },
    true
  );
})();
